import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';

import { Input } from 'antd'
import moment from 'moment'
import { Page,Crud } from '../../components'

const {CrudTable,CrudForm,CrudFilter,CrudButtons} = Crud

export class AlogPage extends Component {
  static propTypes = {
    alog: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount(){
     const { alogPage,currentAlog} = this.props.alog;
     this.fetchList( alogPage);
  }

  fetchList = (page,values) => {
    const {getAlogList} = this.props.actions;
    let params = Object.assign({},{page:page},values)
    getAlogList(params);
  }

  getDataSource() {
    const { alog } = this.props;
    const { alogById, alogList } = alog;
    if (!alogList) return [];
    return alogList.map(id => alogById[id]);
  }

  get listProps() {
    const { alog,actions } = this.props
    const { getAlogListPending,alogTotal,alogPage } = alog
    const { deleteAlog,chooseCurrentAlog,alogModalChange } = actions;

    return {
      dataSource: this.getDataSource(),
      loading: getAlogListPending,
      columns:[
        {
          title: "操作人",
          dataIndex: 'user',
          key: 'user',
          width: 180,
        },
        {
          title: "操作事件",
          dataIndex: 'request',
          key: 'request',
          width: 180,
        },
        {
          title: "请求时间",
          dataIndex: 'requestTime',
          key: 'requestTime',
          width: 180,
        },
        {
          title: "请求参数",
          dataIndex: 'content',
          key: 'content',
          width: 180,
        },
        {
          title: "操作时间",
          dataIndex: 'createAt',
          key: 'createAt',
          width: 180,
          render:(text)=> {
              return moment(text).format('YYYY-MM-DD HH:mm')
          }
        },
      ],
      pagination:{
        total:alogTotal,
        current:alogPage,
        onChange : (page) => {
          this.fetchList(page);
        }
      },
      op:[
        // {
        //   key:3,
        //   name:'删除',
        //   buttonProps:{
        //     icon:"delete",
        //     type:"danger"
        //   },
        //   needConfirm:true,
        //   confirmTitle:"确认删除"
        // }
      ],
      handleMenuClick: (record,item) => {
        if (item.key == 1){
          chooseCurrentAlog(record);
          alogModalChange(true,"updata");
        }else if(item.key == 3){
            deleteAlog(record.id).then((data) => {
            this.fetchList(alogPage);
          })
        }
      }
    }
  } 

  get modalProps() {
    const { alog,actions } = this.props
    const { currentAlog, alogModalVisible,alogPage, alogModalType,submitAlogPending } = alog

    const { alogModalChange,submitAlog } = actions;
    const editItem  = alogModalType === 'create' ? {} : currentAlog
    return {
      item: alogModalType === 'create' ? {} : currentAlog,
      visible: alogModalVisible,
      destroyOnClose: true,
      maskClosable: false,
      confirmLoading: submitAlogPending,
      title: `${
        alogModalType === 'create' ? `创建` : `更新`
      }`,
      centered: true,
      elements: [
        {
          key: "shopName",
          label: "商户名",
          // initialValue: editItem.shopName,
          widget: Input,
          required: true
        },
        {
          key: "score",
          label: "score",
          // initialValue: editItem.score,
          widget: Input,
          required: true
        },
        {
          key: "subAppid",
          label: "商户公众号id",
          // initialValue: editItem.subAppid,
          widget: Input,
          required: true
        },
      ],
      onOk: data => {
        submitAlog(Object.assign({},data,{})).then(data=> {
          alogModalChange(false,"create");
          this.fetchList(alogPage);
        })
      },
      onCancel() {
        alogModalChange(false,"create");
      },
    }
  }

  get filterProps() {
    const { actions,alog } = this.props
    const { currentAlog,alogPage} = alog
    const { alogModalChange } = actions;

    return {
      title:"",
      searchElements: [
        {
            key: "loginId",
            widget: Input,
            widgetProps:{
                placeholder:"请输入登录名"
            },
        },
      ],
      onFilterChange: value => {
         this.fetchList(1,value)
      },
      onAdd() {
        alogModalChange(true,'create')
      },
    }
  }

  get buttonProps() {
    const { actions,alog } = this.props
    const { currentAlog,alogPage} = alog
    const { alogModalChange } = actions;

    return {
        buttons:[
            {
                name:"新增",
                buttonProps:{
                    type:"primary",
                    icon:"plus",
                },
                onClick:()=>{ alogModalChange(true,'create')}
            }
        ]
    }
  }

  render() {
    return (
      <Page inner>
        <CrudTable {...this.listProps} />
        <CrudForm {...this.modalProps} />
      </Page>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    alog: state.alog,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AlogPage);


// WEBPACK FOOTER //
// ./src/features/alog/AlogPage.js